import React, { Component } from "react";
import DataTable from 'react-data-table-component';
import { formatoSeparadorMilesValue } from "../../../generico/utils/FormatoInput";
import $ from "jquery";


const paginationOptions = {
  rangeSeparatorText: "de",
  noRowsPerPage: true
};
export default class AhorroProgramado extends Component {
  constructor(props) {
    super(props);
    this.state = {
      listaAhorro: [],
      descripcion: undefined,
      depositado: undefined,
      ahorro: undefined
    };
  }

  componentDidMount() {
  }

  getColumn() {
    return [
      {
        name: "Descripción",
        selector: row => row.descripcion,
        width: "180px",
      },
      {
        name: "Depositado",
        selector: row => row.depositado
      },
      {
        name: "Cta. Ahorro",
        selector: row => row.ahorro,
        width: "150px",
        right: true
      },
      {
        cell: (row) => (
          <input
            ref={() => this.grupoSel}
            id={"radio_" + row.id}
            type="radio"
            key={row.id}
            type="radio"
            name="rowRadio"
            value={row.id}
            onClick={this.selGrupoEvt}
          ></input>
        ),
        width: "50px",
      },
    ];
  }
  selGrupoEvt = (e) => {

    this.ahorroSele = e.currentTarget;


    for (var i = 0; i < this.props.ahorros.length; i++) {
      var ah = this.props.ahorros[i]
      var ah_id = "radio_" + ah.id;
      if (ah_id === this.ahorroSele.id) {
        this.props.datoAhorro(ah.descripcion, ah.depositado, ah.ahorro);

      }
    }
    this.enableNext();
  };
  enableNext() {
    this.checkGrilla();
  }

  checkGrilla() {
    if (this.ahorroSele !== undefined) {
      $("#" + this.ahorroSele.id).prop("checked", true);
    }
  }


  seleccionarFila(row) {
    this.ahorroSele = document.getElementById("radio_" + row.id)
    this.props.datoAhorro(row.descripcion, row.depositado, row.ahorro);

  }

  obtenerAhorros() {
    if (this.props.ahorros !== undefined && this.props.ahorros.length === 0)
      return (
        <div>
          <span />
        </div>
      )
    return (
      <div>
        <div className="row">
          <div className="col-md-12">
            <label className="input-label-bold">
              Seleccione el Ahorro Programado *
                </label>
            <div className="table-responsive">
              <DataTable
                noHeader={true}
                pagination={true}
                columns={this.getColumn()}
                data={this.props.ahorros}
                dense={true}
                pagination={true}
                paginationComponentOptions={paginationOptions}
                noDataComponent="no hay registros para mostrar"
                responsive={true}
                striped={true}
                pointerOnHover
                onRowClicked={(e) => this.seleccionarFila(e)} />
            </div>
          </div>
        </div>
      </div>
    )
  }


  render() {
    return (
      <div>
        <hr />
        <div className="form-group">
          {this.obtenerAhorros()}
        </div>
      </div>
    );
  }
}
